<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Familia Episode</span>
      <span v-else>Edit Familia Episode </span>
    </h1>

    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-0" cols="12">
            <form-group name="title" :attribute="`fields.title`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.title"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12" class="py-0">
            <section class="increment-label">
              <span>Order</span>
              <number-input
                center
                v-model="form.order"
                :min="1"
                :step="1"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col class="py-0 dates" cols="12" sm="6">
            <v-dialog
              ref="birthdateDialog"
              v-model="date_modal"
              :return-value.sync="form.date.date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.date.date"
                  label="Date"
                  readonly
                  v-on="on"
                  append-icon="icon-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.date.date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="date_modal = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.birthdateDialog.save(form.date.date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col class="py-0" sm="6" cols="12">
            <form-group name="intro" :attribute="`fields.intro`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.intro"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0" sm="6" cols="12">
            <form-group name="full_episode" :attribute="`fields.full_episode`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.full_episode"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import { required, maxLength, url } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        title: "",
        order: "",
        answer: "",
        date: { date: "" }
      },
      date_modal: false,
      maxSize: 1.024,
      resetLogo: false,
      Logo: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      resetBoolean: false
    };
  },

  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createFamiliaEpisode();
      } else {
        this.editFamiliaEpisode();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `content/familia-episodes`,
        id: id
      })
        .then(res => {
          const { familia_episode } = res.data;
          this.form = familia_episode;
          if (familia_episode.date == null) {
            this.form.date = { date: "" };
          }
          if (familia_episode.date !== null) {
            this.form.date = {
              date: this.$moment(this.form.date.date).format("YYYY-MM-DD")
            };
          }
        })
        .catch(() => {});
    },
    createFamiliaEpisode() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD";
      this.form.date = {
        date: this.$moment(this.form.date.date).format(dateFormat)
      };
      Object.keys(this.form).forEach(formItem => {
        console.log(formItem);

        if (formItem === "date") {
          formData.append(formItem, this.form[formItem].date);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      StoreData({
        reqName: `content/familia-episodes`,
        data: formData
      })
        .then(() => {
          this.$router.push("/content/familia-episodes");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editFamiliaEpisode() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (formItem === "date") {
          formData.append(formItem, this.form[formItem].date);
        } else {
          if (this.form[formItem] != null) {
            formData.append(formItem, this.form[formItem]);
          }
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `content/familia-episodes`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push("/content/familia-episodes");
          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "editfamiliaEpisods") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      title: {
        required,
        maxLength: maxLength(255)
      },
      intro: {
        url,
        required
      },
      full_episode: {
        url,
        required
      }
    }
  }
};
</script>
